/* Springwaves theme JS (no dependencies) */
(function () {
  'use strict';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function money(cents) {
    var fmt = (window.theme && window.theme.money) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }

  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 2600);
  }
  window.swToast = toast;

  /* ---------------- Compact header on scroll ---------------- */
  var headerWrap = $('.section-header');
  if (headerWrap) {
    var onHeaderScroll = function () { headerWrap.classList.toggle('is-scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ---------------- Drawers ---------------- */
  // Drawers rendered inside sections (e.g. the sticky header) are moved to <body> so they always sit above the overlay.
  $$('[data-drawer]').forEach(function (d) { if (d.parentElement !== document.body) document.body.appendChild(d); });
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  var lastFocus = null;

  function showOverlay(on) {
    if (!overlay) return;
    if (on) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    else { overlay.classList.remove('is-visible'); setTimeout(function () { if (!openDrawer) overlay.hidden = true; }, 250); }
  }
  function open(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    if (openDrawer && openDrawer !== d) close(true);
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    openDrawer = d;
    document.body.classList.add('no-scroll');
    showOverlay(true);
    setTimeout(function () {
      var f = d.querySelector('[data-predictive-input]') || d.querySelector('button, a, input');
      if (f) f.focus({ preventScroll: true });
    }, 320);
    return true;
  }
  function close(keepOverlay) {
    var d = openDrawer;
    if (!d) return;
    d.classList.remove('is-open');
    openDrawer = null;
    setTimeout(function () { if (openDrawer !== d) d.hidden = true; }, 330);
    if (!keepOverlay) { document.body.classList.remove('no-scroll'); showOverlay(false); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.swDrawer = { open: open, close: close };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      open(id);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openDrawer) close(); });

  /* ---------------- Mobile menu panels ---------------- */
  $$('[data-mnav]').forEach(function (nav) {
    var rootPanel = nav.querySelector('[data-panel="root"]');
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-panel-open]');
      if (btn) {
        var p = nav.querySelector('[data-panel="' + btn.getAttribute('data-panel-open') + '"]');
        if (!p) return;
        p.hidden = false;
        requestAnimationFrame(function () { p.classList.add('is-active'); rootPanel.classList.add('is-behind'); });
        var back = p.querySelector('[data-panel-back]');
        if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, 300);
        return;
      }
      var backBtn = e.target.closest('[data-panel-back]');
      if (backBtn) {
        var panel = backBtn.closest('[data-panel]');
        panel.classList.remove('is-active');
        rootPanel.classList.remove('is-behind');
        setTimeout(function () { panel.hidden = true; }, 300);
      }
    });
  });

  /* ---------------- Announcement bar ---------------- */
  $$('[data-announce]').forEach(function (bar) {
    var msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, parseInt(bar.getAttribute('data-interval'), 10) || 4000);
  });

  /* ---------------- USP marquee: duplicate items so the loop is seamless ---------------- */
  $$('[data-marquee]').forEach(function (list) {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    list.innerHTML += list.innerHTML;
  });

  /* ---------------- Rails ---------------- */
  function initRail(rail) {
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track) return;
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }
  $$('[data-rail]').forEach(initRail);

  /* ---------------- Tabs ---------------- */
  $$('[data-tabs]').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      $$('[data-tab]', wrap).forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
      $$('.tabpanel', wrap).forEach(function (p) {
        var on = p.id === tab.getAttribute('data-tab');
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
    });
  });

  /* ---------------- Read more ---------------- */
  function initReadMore(scope) {
    $$('[data-readmore]', scope).forEach(function (w) {
      var btn = w.querySelector('[data-readmore-btn]');
      var body = w.querySelector('.product__story-body, .col-head__body');
      if (!btn || !body) return;
      requestAnimationFrame(function () {
        if (body.scrollHeight <= body.clientHeight + 6) { btn.hidden = true; w.classList.add('is-open'); }
      });
      btn.addEventListener('click', function () {
        var isOpen = w.classList.toggle('is-open');
        btn.textContent = isOpen ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', isOpen);
      });
    });
  }
  initReadMore(document);

  /* ---------------- Reveal on scroll ---------------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); revealIO.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function initReveal(scope) {
    $$('.reveal', scope).forEach(function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-visible'); });
  }
  initReveal(document);

  /* ---------------- Dialogs ---------------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-dialog-open]');
    if (o) {
      var d = document.getElementById(o.getAttribute('data-dialog-open'));
      if (d && d.showModal) d.showModal();
      return;
    }
    var c = e.target.closest('[data-dialog-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('modal')) e.target.close();
  });

  /* ---------------- Footer accordions closed on mobile ---------------- */
  if (window.matchMedia('(max-width: 989px)').matches) {
    $$('.footer__col[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* ---------------- Stone finder intention filter ---------------- */
  $$('[data-stone-finder]').forEach(function (sec) {
    sec.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-intent]');
      if (!chip) return;
      var key = chip.getAttribute('data-intent');
      $$('[data-intent]', sec).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      $$('.stones__item', sec).forEach(function (it) {
        var list = (it.getAttribute('data-intents') || '').split(' ');
        it.classList.toggle('is-hidden', key !== 'all' && list.indexOf(key) === -1);
      });
      var track = sec.querySelector('[data-rail-track]');
      if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
    });
  });

  /* ---------------- Cart ---------------- */
  var Cart = {
    sectionsFor: function () {
      var ids = [];
      if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
      var page = $('[data-cart-page]');
      if (page) {
        var sec = page.closest('.shopify-section');
        if (sec) ids.push(sec.id.replace('shopify-section-', ''));
      }
      return ids;
    },
    refresh: function (sections) {
      var ids = Cart.sectionsFor();
      var apply = function (map) {
        ids.forEach(function (id) {
          if (!map || !map[id]) return;
          var doc = new DOMParser().parseFromString(map[id], 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          var target = id === 'cart-drawer' ? $('#CartDrawer [data-cart-body]') : $('[data-cart-page] [data-cart-body]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          if (id === 'cart-drawer') {
            var t = doc.querySelector('.drawer__title');
            var tt = $('#CartDrawer .drawer__title');
            if (t && tt) tt.innerHTML = t.innerHTML;
          }
        });
        Cart.giftBanner();
      };
      var counts = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
        return c;
      });
      if (sections) { apply(sections); return counts; }
      if (!ids.length) return counts;
      return Promise.all([counts, fetch(root + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(apply)]);
    },
    add: function (formData) {
      var ids = Cart.sectionsFor();
      if (ids.length) { formData.append('sections', ids.join(',')); formData.append('sections_url', window.location.pathname); }
      return fetch(root + 'cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (j) {
          return Cart.refresh(j.sections).then(function () {
            if (window.theme.cartType === 'drawer' && document.getElementById('CartDrawer')) open('CartDrawer');
            else toast(window.theme.strings.added || 'Added to your bag');
            return j;
          });
        });
    },
    change: function (line, qty) {
      var body = $('#CartDrawer [data-cart-body]') || $('[data-cart-page] [data-cart-body]');
      if (body) body.style.opacity = '.55';
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty, sections: Cart.sectionsFor(), sections_url: window.location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { return Cart.refresh(j.sections); })
        .finally(function () { if (body) body.style.opacity = ''; });
    },
    giftBanner: function () {
      var gift = store.get('sw_gift', null);
      $$('[data-gift-banner]').forEach(function (b) {
        if (!gift || !gift.code) { b.hidden = true; return; }
        b.hidden = false;
        var t = b.querySelector('[data-gift-text]');
        if (t) t.textContent = gift.label + ' (' + gift.code + ') will be applied at checkout';
      });
    }
  };
  window.swCart = Cart;
  Cart.giftBanner();

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (!q) return;
    e.preventDefault();
    Cart.change(parseInt(q.getAttribute('data-line'), 10), Math.max(0, parseInt(q.getAttribute('data-cart-qty'), 10)));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    Cart.add(new FormData(form)).catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that could not be added'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Gift message -> cart note (saved as the customer types)
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-cart-note]');
    if (!ta) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: ta.value }) })
        .then(function () { var s = ta.parentElement.querySelector('[data-note-saved]'); if (s) { s.hidden = false; setTimeout(function () { s.hidden = true; }, 1600); } })
        .catch(function () {});
    }, 600);
  });

  /* ---------------- Product page ---------------- */
  function initProduct(section) {
    var gallery = section.querySelector('[data-gallery]');
    var track = gallery && gallery.querySelector('[data-track]');
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var count = gallery && gallery.querySelector('[data-count]');
    var slides = track ? $$('.gallery__slide', track) : [];

    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var at = thumbs[i];
      if (at) {
        var list = at.closest('[data-thumbs]');
        var li = at.parentElement;
        if (list && li) list.scrollTo({ top: li.offsetTop - list.clientHeight / 2 + li.clientHeight / 2, behavior: 'smooth' });
      }
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var cur = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, cur() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, cur() + 1)); });
      // keep the thumbnail column the same height as the main image
      var thumbList = gallery.querySelector('[data-thumbs]');
      var sizeThumbs = function () { if (thumbList) thumbList.style.maxHeight = track.clientHeight + 'px'; };
      sizeThumbs();
      window.addEventListener('resize', sizeThumbs);
    }

    // Lightbox
    var lb = section.querySelector('[data-lightbox]');
    if (lb && lb.showModal) {
      section.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (!z) return;
        var idx = z.getAttribute('data-zoom');
        lb.showModal();
        var target = lb.querySelector('.lightbox__slide[data-index="' + idx + '"]');
        if (target) target.scrollIntoView({ block: 'nearest', inline: 'center' });
      });
      lb.querySelector('[data-lightbox-close]').addEventListener('click', function () { lb.close(); });
    }

    // Quantity
    var qty = section.querySelector('[data-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      qty.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }

    // Variants
    var picker = section.querySelector('[data-variant-picker]');
    var form = section.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addLabel = section.querySelector('[data-add-label]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var priceWrap = section.querySelector('[data-price-wrap]');
    var variants = [];
    if (picker) {
      try { variants = JSON.parse(picker.querySelector('[data-variants]').textContent); } catch (err) { variants = []; }
      picker.addEventListener('change', function () {
        var opts = $$('[data-option-index]', picker).map(function (fs) {
          var c = fs.querySelector('input:checked');
          var label = fs.querySelector('[data-option-value]');
          if (c && label) label.textContent = c.value;
          return c ? c.value : null;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        updateVariant(v);
      });
      markUnavailable();
    }
    function markUnavailable() {
      // grey out values that only exist as sold-out combinations (single-option products)
      if (!variants.length || variants[0].options.length !== 1) return;
      $$('[data-option-input]', picker).forEach(function (inp) {
        var v = variants.find(function (x) { return x.options[0] === inp.value; });
        var lab = inp.nextElementSibling;
        if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function updateVariant(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = window.theme.strings.unavailable; }
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut; }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (priceWrap) {
        var cur = priceWrap.querySelector('[data-current]');
        var cmp = priceWrap.querySelector('[data-compare]');
        var sav = priceWrap.querySelector('[data-saving]');
        var wrap = priceWrap.querySelector('[data-price]');
        if (cur) cur.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (wrap) wrap.classList.toggle('price--sale', !!onSale);
        if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? money(v.compare_at_price) : ''; }
        if (sav) { sav.hidden = !onSale; if (onSale) sav.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      }
      if (v.featured_media && track) {
        var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) goTo(parseInt(slide.getAttribute('data-index'), 10));
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      section.dispatchEvent(new CustomEvent('variant:change', { detail: v }));
    }

    // Add to bag
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = form.querySelector('[data-form-error]');
        if (err) err.hidden = true;
        if (addBtn) addBtn.classList.add('is-loading');
        if (addBtn) addBtn.disabled = true;
        Cart.add(new FormData(form)).catch(function (j) {
          if (err) { err.textContent = (j && (j.description || j.message)) || 'Sorry, something went wrong.'; err.hidden = false; }
        }).finally(function () { if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.disabled = false; } });
      });
    }

    // Sticky add to bag (mobile)
    var sticky = section.querySelector('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    // Stock line + delivery countdown ("Order within 5h 12m to get it Fri 9 Oct – Mon 12 Oct")
    var del = section.querySelector('[data-delivery]');
    if (del) {
      var ukDays = parseInt(del.getAttribute('data-uk-days'), 10) || 2;
      var lowAt = parseInt(del.getAttribute('data-low'), 10) || 5;
      var stock = {};
      try { stock = JSON.parse(del.querySelector('[data-stock]').textContent); } catch (err) { stock = {}; }
      var addWorkingDays = function (d, n) {
        var x = new Date(d);
        while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; }
        return x;
      };
      var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var eta = del.querySelector('[data-eta]');
      var tick = function () {
        var now = new Date();
        var midnight = new Date(now); midnight.setHours(24, 0, 0, 0);
        var mins = Math.max(1, Math.round((midnight - now) / 60000));
        var h = Math.floor(mins / 60), m = mins % 60;
        var left = (h ? h + 'h ' : '') + m + 'm';
        var from = addWorkingDays(now, 1 + ukDays);
        var to = addWorkingDays(now, 2 + ukDays);
        if (eta) eta.innerHTML = 'Order within <strong class="delivery__timer">' + left + '</strong> to get it <strong>' + fmt(from) + ' – ' + fmt(to) + '</strong>';
      };
      tick();
      setInterval(tick, 30000);
      var stockLine = del.querySelector('[data-stock-line]');
      var stockText = del.querySelector('[data-stock-text]');
      var showStock = function (v) {
        if (!stockText || !v) return;
        var q = stock[String(v.id)];
        var dot = stockLine.querySelector('.dot');
        if (!v.available) { stockText.textContent = 'Sold out'; dot.className = 'dot dot--out'; return; }
        if (typeof q === 'number' && q > 0 && q <= lowAt) { stockText.textContent = 'Only ' + q + ' left in stock, order soon'; dot.className = 'dot dot--low'; return; }
        stockText.textContent = 'In stock, ready to ship'; dot.className = 'dot';
      };
      section.addEventListener('variant:change', function (e) { showStock(e.detail); });
      var firstId = idInput && idInput.value;
      if (firstId) showStock(variants.find(function (x) { return String(x.id) === String(firstId); }) || { id: firstId, available: true });
    }

    // Copy link
    $$('[data-copy-link]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-copy-link');
        (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { b.textContent = 'Link copied'; }).catch(function () { window.prompt('Copy this link', t); });
      });
    });

    // Recently viewed
    var url = section.getAttribute('data-url');
    var title = section.querySelector('.product__title');
    var img = section.querySelector('.gallery__slide img');
    var price = section.querySelector('[data-current]');
    if (url && title) {
      var list = store.get('sw_recent', []).filter(function (p) { return p.url !== url; });
      list.unshift({ url: url, title: title.textContent.trim(), img: img ? (img.currentSrc || img.src) : '', price: price ? price.textContent.trim() : '' });
      store.set('sw_recent', list.slice(0, 12));
    }
  }
  $$('[data-product]').forEach(initProduct);

  // Recommendations + recently viewed
  $$('[data-recommendations]').forEach(function (sec) {
    if (sec.querySelector('.rail')) return;
    fetch(sec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; $$('[data-rail]', sec).forEach(initRail); }
    }).catch(function () {});
  });
  $$('[data-recently-viewed]').forEach(function (sec) {
    var here = window.location.pathname;
    var items = store.get('sw_recent', []).filter(function (p) { return p.url !== here && here.indexOf(p.url) === -1; }).slice(0, 8);
    if (items.length < 2) return;
    var ul = sec.querySelector('[data-recent-list]');
    ul.innerHTML = items.map(function (p) {
      var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      return '<li class="rail__item"><div class="card"><a class="card__media" href="' + esc(p.url) + '">' + (p.img ? '<img class="card__img" src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a><div class="card__info"><a class="card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="price price--small"><span>' + esc(p.price) + '</span></div></div></div></li>';
    }).join('');
    sec.hidden = false;
  });

  /* ---------------- Predictive search ---------------- */
  $$('[data-predictive-input]').forEach(function (input) {
    var results = input.closest('[data-search-drawer]').querySelector('[data-predictive-results]');
    var initial = results.innerHTML;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = initial; return; }
      timer = setTimeout(function () {
        fetch(window.theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.pred');
            results.innerHTML = sec ? sec.outerHTML : '<p class="muted">No results for “' + q.replace(/</g, '&lt;') + '”.</p>';
          }).catch(function () {});
      }, 220);
    });
  });

  /* ---------------- Collection page ---------------- */
  $$('[data-collection]').forEach(function (sec) {
    var sort = sec.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });

    var grid = sec.querySelector('[data-grid]');
    var more = sec.querySelector('[data-load-more]');
    var progress = sec.querySelector('[data-progress]');
    var total = grid ? parseInt(grid.getAttribute('data-pages'), 10) : 1;
    var current = grid ? parseInt(grid.getAttribute('data-current'), 10) : 1;
    var sectionId = sec.getAttribute('data-section-id');
    var loadingAll = null;

    function pageUrl(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', n);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }
    function fetchPage(n) {
      return fetch(pageUrl(n)).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('[data-grid] > .grid__item', doc);
        items.forEach(function (it) { grid.appendChild(document.importNode(it, true)); });
        current = n;
      });
    }
    var perPage = grid ? $$('.grid__item', grid).length : 0;
    var shownCount = perPage;
    var allLoaded = total <= current;
    function filtering() { return activeType !== 'all' || activeStone !== 'all'; }
    function updateMore() {
      if (!grid) return;
      var items = $$('.grid__item', grid);
      if (filtering()) {
        items.forEach(function (it) { it.classList.remove('is-paged'); });
        if (more) more.parentElement.hidden = true;
        return;
      }
      items.forEach(function (it, i) { it.classList.toggle('is-paged', i >= shownCount); });
      var visible = Math.min(shownCount, items.length);
      var totalCount = allLoaded ? items.length : parseInt(grid.getAttribute('data-total') || items.length, 10);
      if (progress) progress.textContent = 'Showing ' + visible + ' of ' + totalCount;
      if (more) more.parentElement.hidden = allLoaded && visible >= items.length;
    }
    if (more) more.addEventListener('click', function (e) {
      e.preventDefault();
      if (allLoaded || $$('.grid__item', grid).length > shownCount) {
        shownCount += perPage;
        updateMore();
        return;
      }
      more.textContent = 'Loading…';
      fetchPage(current + 1).then(function () {
        allLoaded = current >= total;
        shownCount += perPage;
        more.textContent = 'Load more';
        updateMore(); applyFilter();
      });
    });
    function loadAll() {
      if (loadingAll) return loadingAll;
      var chain = Promise.resolve();
      for (var n = current + 1; n <= total; n++) { (function (p) { chain = chain.then(function () { return fetchPage(p); }); })(n); }
      loadingAll = chain.then(function () { allLoaded = true; updateMore(); });
      return loadingAll;
    }

    // Quick filters: build type & stone pills with live counts
    var quick = sec.querySelector('[data-quick]');
    var activeType = 'all', activeStone = 'all';
    function counts() {
      var types = {}, stones = {};
      $$('.card', grid).forEach(function (c) {
        var t = c.getAttribute('data-type');
        types[t] = (types[t] || 0) + 1;
        (c.getAttribute('data-stones') || '').split(',').forEach(function (s) { if (s) stones[s] = (stones[s] || 0) + 1; });
      });
      return { types: types, stones: stones };
    }
    function buildQuick() {
      if (!quick || !grid) return;
      var c = counts();
      var typeBtns = $$('[data-qf-type]', quick);
      var shownTypes = 0;
      typeBtns.forEach(function (b) {
        var n = c.types[b.getAttribute('data-qf-type')] || 0;
        b.parentElement.hidden = n === 0;
        if (n) { shownTypes++; b.querySelector('[data-n]').textContent = n; }
      });
      var typeRow = quick.querySelector('[data-quick-types]');
      var totalCards = $$('.card', grid).length || 1;
      var maxType = Math.max.apply(null, Object.keys(c.types).map(function (k) { return c.types[k]; }).concat([0]));
      if (maxType / totalCards >= 0.9) shownTypes = 0; // e.g. "Necklaces": a type filter adds nothing
      if (typeRow) typeRow.closest('.pills-scroll').hidden = shownTypes < 2;
      var stoneRow = quick.querySelector('[data-quick-stones]');
      var shownStones = 0;
      if (stoneRow) {
        $$('[data-qf-stone]', stoneRow).forEach(function (b) {
          var n = c.stones[b.getAttribute('data-qf-stone')] || 0;
          b.parentElement.hidden = n === 0;
          if (n) { shownStones++; b.querySelector('[data-n]').textContent = n; }
        });
        stoneRow.closest('.pills-scroll').hidden = shownStones < 2;
      }
      quick.hidden = shownTypes < 2 && shownStones < 2;
    }
    function applyFilter() {
      if (!grid) return;
      var visible = 0;
      $$('.grid__item', grid).forEach(function (it) {
        var c = it.querySelector('.card');
        var okT = activeType === 'all' || (c && c.getAttribute('data-type') === activeType);
        var okS = activeStone === 'all' || (c && (',' + c.getAttribute('data-stones') + ',').indexOf(',' + activeStone + ',') > -1);
        it.classList.toggle('is-filtered', !(okT && okS));
        if (okT && okS) visible++;
      });
      var empty = sec.querySelector('[data-empty]');
      if (empty) empty.hidden = visible > 0;
      var countText = sec.querySelector('[data-count-text]');
      if (countText && (activeType !== 'all' || activeStone !== 'all')) countText.textContent = visible + (visible === 1 ? ' piece' : ' pieces');
    }
    if (quick && grid) {
      // collections up to 6 pages: fetch everything in the background so counts are complete
      if (total <= 6 && total > current) loadAll().then(buildQuick); else buildQuick();
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qf], [data-qf-type], [data-qf-stone]');
        if (!b) return;
        if (b.hasAttribute('data-qf')) { activeType = 'all'; activeStone = 'all'; }
        if (b.hasAttribute('data-qf-type')) activeType = activeType === b.getAttribute('data-qf-type') ? 'all' : b.getAttribute('data-qf-type');
        if (b.hasAttribute('data-qf-stone')) activeStone = activeStone === b.getAttribute('data-qf-stone') ? 'all' : b.getAttribute('data-qf-stone');
        $$('[data-qf]', quick).forEach(function (x) { x.classList.toggle('is-active', activeType === 'all' && activeStone === 'all'); });
        $$('[data-qf-type]', quick).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-qf-type') === activeType); });
        $$('[data-qf-stone]', quick).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-qf-stone') === activeStone); });
        loadAll().then(function () { applyFilter(); updateMore(); });
      });
    }
  });

  // Filter drawer: submit as a clean URL
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
      window.location.search = params.toString();
    });
  });
})();
